import {Component, ElementRef, Injector, OnInit, Renderer2} from '@angular/core';
import {User} from '../Models/user.model';
import {SharedService} from '../services/shared.service';
import {Router} from '@angular/router';
import {CategoryService} from '../services/category.service';
import {UserService} from '../services/user.service';
import {Category} from '../Models/category.model';
import * as moment from 'moment';
import {TaskApi} from '../Models/task-api.model';
import {TaskService} from '../services/task.service';
import {Pomodoro} from '../Models/Pomodoro';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {RankService} from '../services/rank.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  public selectedCat = '';
  public userTaskInfo = {
    sumDurationPomodoro: '',
    sumCountPomodoro: ''
  };
  public userInfo = {
    name: '',
    mobile: '',
    picture: ''
  };
  public showPagination = false;
  public spinner = false;
  public cardSpinner = false;
  public username;
  public tab: any = 'tab1';
  public tab1: any;
  public tab2: any;
  public tab3: any;
  public p = 1;
  public collection: any;
  public a = 1;
  public pomodoroRepository: PomodoroRepository;
  public tasks: Pomodoro[];
  public task: TaskApi = new TaskApi();
  public user: User = new User();
  public category: Category[];
  public title;
  public myError: any = 'خطا';
  public pomoDate = [];
  public todayTasks = [];
  public yesterdayTask;
  public weekTasks;
  public monthTasks;
  public formatHour;
  public todaySumHour;
  public yesterdaySumHour;
  public lastWeekSumHour;
  public lastMonthSumHour;
  public timeAllPomodoroHandler;
  public timeAllPomodoro;
  public numberAllPomodoro;
  public countFormat;
  public taskWithCategory;
  public pomodoro = new Pomodoro();
  public sumOfOneCategory;
  public formatSumOfOneCategory;
  public userRank;
  public allCategory = 'همه دسته بندی ها';
  constructor(public sharedService: SharedService,
              private router: Router,
              public categoryService: CategoryService,
              public userService: UserService,
              private taskService: TaskService,
              private injector: Injector,
              private rankService: RankService,
              private renderer: Renderer2,
              private el: ElementRef) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    this.pomodoroRepository.userIsLoggedIn = true;
    this.categoryService.getListOfUsersCategory().subscribe(
      (data) => {
        this.pomodoroRepository.categories = data;
      }, (err) => {
        if (err.status === 500 && err.error === 'Unauthenticated.') {
          this.pomodoroRepository.prevLang = localStorage.getItem('trans');
          localStorage.clear();
          localStorage.setItem('trans', this.pomodoroRepository.prevLang);
          this.pomodoroRepository.userIsLoggedIn = false;
          this.router.navigateByUrl('/login').then();
        }
      }
    );
    if (this.username === null){
      this.username = '-';
    }
    this.getTodayTask();
    this.getSumOfDone();
    this.getUserRank();
    this.getCurrentUser();
    this.getUsersTask();
  }
  changeToEdit(): any{
    this.router.navigateByUrl('edit').then();
  }
  getTodayTask(): any{
    this.pomoDate = this.todayTasks;
    this.spinner = true;
    this.taskService.getTodayTask().subscribe(
      (data) => {
        // this.todayTasks = data.data.done;
        this.todaySumHour = data.sum_length;
        this.countFormat = data.sum_count;
        this.formatHour = moment().startOf('day').add(this.todaySumHour, 'minutes').format('HH:mm');
        // this.pomoDate = this.todayTasks;
        const x = data.data.done;
        const y = [];
        x.forEach(z => {
          const w = y.length - 1;
          if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
            y[w].count += z.count;
            y[w].time_length += z.time_length;
          }
          else {
            y.push(z);
          }
        });
        this.pomoDate = y;
        this.spinner = false;
        if (this.pomoDate.length > 10){
          this.showPagination = true;
        } else {
          this.showPagination = false;
        }
      }
    );
  }
  getYesterdayTask(): any{
    this.pomoDate = this.yesterdayTask;
    this.spinner = true;
    this.taskService.getYesterdayTask().subscribe(
      (data) => {
        // this.yesterdayTask = data.data.done;
        this.yesterdaySumHour = data.sum_length;
        this.countFormat = data.sum_count;
        this.formatHour = moment().startOf('day').add(this.yesterdaySumHour, 'minutes').format('HH:mm');
        // this.pomoDate = this.yesterdayTask;
        const x = data.data.done;
        const y = [];
        x.forEach(z => {
          const w = y.length - 1;
          if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
            y[w].count += z.count;
            y[w].time_length += z.time_length;
          }
          else {
            y.push(z);
          }
        });
        this.pomoDate = y;
        this.spinner = false;
        if (this.pomoDate.length > 10){
          this.showPagination = true;
        } else {
          this.showPagination = false;
        }
      }
    );
  }
  getThisWeekTask(): any{
    this.pomoDate = this.weekTasks;
    this.spinner = true;
    this.taskService.getThisWeekTask().subscribe(
      (data) => {
        this.weekTasks = data.data.done;
        this.lastWeekSumHour = data.sum_length;
        this.countFormat = data.sum_count;
        this.formatHour = moment().startOf('day').add(this.lastWeekSumHour, 'minutes').format('HH:mm');
        // this.pomoDate = this.weekTasks;
        const x = data.data.done;
        const y = [];
        x.forEach(z => {
          const w = y.length - 1;
          if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
            y[w].count += z.count;
            y[w].time_length += z.time_length;
          }
          else {
            y.push(z);
          }
        });
        this.pomoDate = y;
        this.spinner = false;
        if (this.pomoDate.length > 10){
          this.showPagination = true;
        } else {
          this.showPagination = false;
        }
      }
    );
  }
  getThisMonthTask(): any{
    this.pomoDate = this.monthTasks;
    this.spinner = true;
    this.taskService.getThisMonthTask().subscribe(
      (data) => {
        this.lastMonthSumHour = data.sum_length;
        this.countFormat = data.sum_count;
        this.formatHour = moment().startOf('day').add(this.lastMonthSumHour, 'minutes').format('HH:mm');
        // this.pomoDate = this.monthTasks;
        const x = data.data.done;
        const y = [];
        x.forEach(z => {
          const w = y.length - 1;
          if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
            y[w].count += z.count;
            y[w].time_length += z.time_length;
          }
          else {
            y.push(z);
          }
        });
        this.pomoDate = y;
        this.spinner = false;
        if (this.pomoDate.length > 10){
          this.showPagination = true;
        } else {
          this.showPagination = false;
        }
      }
    );
  }
  getCategoryDetails(): any{
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.categoryService.getCategoryDetails(this.category).subscribe();
    } else {
      return this.myError;
    }
  }
  getSumOfDone(): any{
    this.taskService.getTodayTask().subscribe(
      (data) => {
        this.todaySumHour = data.sum_length;
        this.formatHour = moment().startOf('day').add(this.todaySumHour, 'minutes').format('HH:mm');
      }
    );
  }
  onClick(check): any{
    if (check === 1){
      this.tab = 'tab1';
      this.p = 1;
      this.selectedCat = this.pomodoroRepository.allCategory;
    }else if (check === 2){
      this.tab = 'tab2';
      this.p = 1;
      this.selectedCat = this.pomodoroRepository.allCategory;
    }else if (check === 3){
      this.tab = 'tab3';
      this.p = 1;
      this.selectedCat = this.pomodoroRepository.allCategory;
    }else if (check === 4){
      this.tab = 'tab4';
      this.p = 1;
      this.selectedCat = this.pomodoroRepository.allCategory;
    }
  }
  getUserRank(): any{
    this.rankService.testUserRank().subscribe(
      (data) => {
        this.userRank = data.rank;
        this.timeAllPomodoroHandler = data.sum_of_pomodoro_time;
        // this.timeAllPomodoro = moment().startOf('day').add(this.timeAllPomodoroHandler, 'minutes').format('HH:mm');
        this.timeAllPomodoro = moment.duration(data.sum_of_pomodoro_time, 'minutes').format('HH:mm');
        this.numberAllPomodoro = data.count_of_pomodoro;
      }
    );
  }
  getCurrentUser(): any{
    this.cardSpinner = true;
    this.userService.getCurrentUserInfo().subscribe(
      (data) => {
      this.userInfo.name = data.name;
      this.userInfo.mobile = data.mobile;
      this.userInfo.picture = data.profile_photo_url;
      localStorage.setItem('isPremium', data.is_premium);
      localStorage.setItem('premiumUntil', data.premium_until);
      this.cardSpinner = false;
      }
    );
  }
  // getAllDoneTask(): any{
  //   this.taskService.getAllDoneTaskInfo().subscribe(
  //     (data) => {
  //       this.timeAllPomodoroHandler = data.sum_length;
  //       this.timeAllPomodoro = moment().startOf('day').add(this.timeAllPomodoroHandler, 'minutes').format('HH:mm');
  //       this.numberAllPomodoro = data.sum_count;
  //     }
  //   );
  // }
  sendCategory(category: any): any{
    this.selectedCat = category.target.value;
    if (this.tab === 'tab1' && this.selectedCat === this.pomodoroRepository.allCategory){
      this.getTodayTask();
    }
    if (this.tab === 'tab2' && this.selectedCat === this.pomodoroRepository.allCategory){
      this.getYesterdayTask();
    }
    if (this.tab === 'tab3' && this.selectedCat === this.pomodoroRepository.allCategory){
      this.getThisWeekTask();
    }
    if (this.tab === 'tab4' && this.selectedCat === this.pomodoroRepository.allCategory){
      this.getThisMonthTask();
    }
    if (this.tab === 'tab1'){
      this.taskService.getTodayTaskWithCategory(this.selectedCat).subscribe(
        (data) => {
          this.sumOfOneCategory = data.sum_length;
          this.countFormat = data.sum_count;
          this.formatSumOfOneCategory = moment().startOf('day').add(this.sumOfOneCategory, 'minutes').format('HH:mm');
          const x = data.data.done;
          const y = [];
          x.forEach(z => {
            const w = y.length - 1;
            if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
              y[w].count += z.count;
              y[w].time_length += z.time_length;
            }
            else {
              y.push(z);
            }
          });
          this.pomoDate = y;
        }
      );
    } else if (this.tab === 'tab2') {
      this.taskService.getYesterdayTaskWithCategory(this.selectedCat).subscribe(
        (data) => {
          // this.taskWithCategory = data.data.done;
          this.sumOfOneCategory = data.sum_length;
          this.countFormat = data.sum_count;
          this.formatSumOfOneCategory = moment().startOf('day').add(this.sumOfOneCategory, 'minutes').format('HH:mm');
          const x = data.data.done;
          const y = [];
          x.forEach(z => {
            const w = y.length - 1;
            if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
              y[w].count += z.count;
              y[w].time_length += z.time_length;
            }
            else {
              y.push(z);
            }
          });
          this.pomoDate = y;
        }
      );
    } else if (this.tab === 'tab3') {
      this.taskService.getWeekTaskWithCategory(this.selectedCat).subscribe(
        (data) => {
          this.sumOfOneCategory = data.sum_length;
          this.countFormat = data.sum_count;
          this.formatSumOfOneCategory = moment().startOf('day').add(this.sumOfOneCategory, 'minutes').format('HH:mm');
          const x = data.data.done;
          const y = [];
          x.forEach(z => {
            const w = y.length - 1;
            if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
              y[w].count += z.count;
              y[w].time_length += z.time_length;
            }
            else {
              y.push(z);
            }
          });
          this.pomoDate = y;
        }
      );
    } else if (this.tab === 'tab4') {
      // this.getThisMonthTask();
      this.taskService.getMonthTaskWithCategory(this.selectedCat).subscribe(
        (data) => {
          // this.taskWithCategory = data.data.done;
          this.sumOfOneCategory = data.sum_length;
          this.countFormat = data.sum_count;
          this.formatSumOfOneCategory = moment().startOf('day').add(this.sumOfOneCategory, 'minutes').format('HH:mm');
          // this.pomoDate = this.taskWithCategory;
          const x = data.data.done;
          const y = [];
          x.forEach(z => {
            const w = y.length - 1;
            if (w >= 0 && z.description === y[w].description && z.category === y[w].category) {
              y[w].count += z.count;
              y[w].time_length += z.time_length;
            }
            else {
              y.push(z);
            }
          });
          this.pomoDate = y;
        }
      );
    }
  }
  getUsersTask(): any{
    this.taskService.getList().subscribe(
      (data) => {
        this.userTaskInfo.sumCountPomodoro = data.sum_count;
        // this.userTaskInfo.sumDurationPomodoro = data.sum_length;
        // this.userTaskInfo.sumCountPomodoro = moment().startOf('day').add(data.sum_count, 'minutes').format('HH:mm');
        this.userTaskInfo.sumDurationPomodoro = moment.duration(data.sum_length, 'minutes').format('HH:mm');
      }
    );
  }
}
